exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rootContainer---1XRuo{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:100%}", ""]);

// exports
exports.locals = {
	"rootContainer": "rootContainer---1XRuo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/root-container/index.scss
// module id = 760
// module chunks = 3